import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useDeleteAIAgentTemplateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: () => void;
	onError?: (error: any) => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async ({ id }: { id: string }) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({ urlPath: `aiagenttemplate/${id}` }),
				'DELETE'
			);
		},
		onSuccess,
		onError,
	});
}
